import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppConfig } from 'src/app/common/app-config/app-config.interface';
import { AppConfigService } from 'src/app/common/app-config/app-config.service';
import { GlobalConstants } from 'src/app/common/global';
import { Language } from 'src/app/common/languages.config';
import { Services } from 'src/app/services/api.service';
import { LanguageService } from 'src/app/services/language.service';
import { ProfileService } from 'src/app/services/profile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: `./${environment.pageFolder}/footer.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/footer.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [TranslateModule, RouterModule, CommonModule]
})

export class FooterComponent {
  redirectUrl = environment.redirectUrl;
  appConfig: AppConfig;
  public readonly languageEnum = Language;
  public readonly officialWebsiteUrl = environment.officialWebsiteUrl;
  userHasMembership: boolean = true;
  isAuth: boolean = false;
  readonly becomingMemberDisabled: boolean = environment.becomingMemberDisabled;

  constructor(
    public languageService: LanguageService,
    public services: Services,
    public appConfigService: AppConfigService,
    private profileService: ProfileService
  ) {
    this.appConfig = appConfigService.getConfig();

    if(environment.configId === "4" && GlobalConstants.isAuth) {
      this.profileService.getMemberships(true).subscribe({
        next: (data) => {
          const response: any = data;
          this.userHasMembership = (response.data.own || response.data.others.length > 0) ? true : false;
        }
      });
    }
  }

  ngOnInit() {
    this.isAuth = GlobalConstants.isAuth;
  }
}
